import yup from '../../Utils/yup';

export const createOfferTemplateFormRules = yup.object().shape({
  name: yup.string().required()
});
